import Cookies from 'js-cookie';
import { getConsent } from '../Consent/consentUtil';

export enum EventName {
    GaEvent = 'web-ga-event',
    PageView = 'pageview',
}

export enum EventInfoCategory {
    SavingsCalculator = 'SavingsCalculator',
    HistoricReturnCalculator = 'HistoricReturnCalculator',
    Withdrawal = 'WithdrawalCalculator',
    GobiBubbles = 'GobiBubbles',
    Consent = 'Consent',
    Newsletter = 'Newsletter',
    Podcast = 'Podcast',
    FundList = 'FundList',
    Campaign = 'Campaign',
    PerformanceCalculator = 'PerformanceCalculator',
    GenesysChat = 'GenesysChat',
    FundCostList = 'FundCostList',
    SkagenForceEvent = 'SkagenForceEvent',
    SliderContentBlock = 'SliderContent',
    PortfolioOverviewBlockApp = 'PortfolioOverviewBlockApp',
}

export enum EventInfoAction {
    Displayed = 'Displayed',
    None = 'None',
    Input = 'Input',
    Button = 'Button',
}

export interface EventInfo {
    title?: string;
    action?: string;
    category?: string;
    value?: string;
    funnel?: string;
    date?: string;
    fund?: string;
    isin?: string;
    recommended?: string;
    accountType?: string;
    periodicity?: string;
    autoPayment?: boolean;
    endDate?: string;
    monthlyPayment?: string;
    oneTimePayment?: string;
    purchaseType?: string;
    currency?: string;
}

export interface EnvironmentInfo {
    environment: string;
    language: string;
    market: string;
    brand: string;
}

export interface PageInfo {
    type?: string;
    openPage?: boolean;
}
export interface FundInfo {
    type?: string;
}
export interface UserInfo {
    id?: string;
    loggedIn?: boolean;
}

export interface TrackingEvent {
    event: EventName;
    eventInfo?: EventInfo;
    fundInfo?: FundInfo;
    pageInfo?: PageInfo;
}

interface GtmInternalEvent {
    environmentInfo: EnvironmentInfo;
    userInfo: UserInfo;
    consent: Consent;
}

export interface Consent {
    basic: boolean;
    useful: boolean;
    analytics: boolean;
    marketing: boolean;
}

const language = document.documentElement.getAttribute('lang') || 'no';
const environment =
    document.documentElement.getAttribute('data-environment') || 'development';
const market = document.documentElement.getAttribute('data-market') || 'no';
const brand = document.documentElement.getAttribute('data-brand') || 'SKAGEN';
const cipId = Cookies.get('CIP-ID');
const consent = getConsent();

const gtmInternalEventData: GtmInternalEvent = {
    environmentInfo: { brand, environment, language, market },
    userInfo: { id: cipId, loggedIn: !!cipId },
    consent,
};

export const trackEvent = async (event: TrackingEvent) => {
    const data = { ...event, ...gtmInternalEventData };
    window.dataLayer.push(data);

    if (window.localStorage.getItem('webDebug') !== null) {
        const eventAsJson = JSON.stringify(data);
        // eslint-disable-next-line no-console
        console.log('%c' + eventAsJson, 'color:#fff; background:#69f');
    }
};

/**
 * Will track a predefined and open GA event.
 *
 * The event trigger in GTM is: web-ga-event.
 * The protocol is set ut to read:
 * eventInfo.category
 * eventInfo.action
 * eventInfo.title
 * eventInfo.value
 *
 * @param category - ends up as category in GA Event Tracking
 * @param action - ends up as action in GA Event Tracking
 * @param title - ends up as label in GA Event Tracking
 * @param value - ends up as value in GA Event Tracking
 */

export const trackTradidionalGaEvent = (
    category: EventInfoCategory,
    action: EventInfoAction,
    title: string,
    value?: string
): void => {
    trackEvent({
        event: EventName.GaEvent,
        eventInfo: {
            category,
            action,
            title,
            value,
        },
    });
};

export const trackPageView = (): void => {
    trackEvent({
        event: EventName.PageView,
    });
};
